import React from 'react'
import './Home.css'
 
const Name = (props) => {
    return (
        <div className = 'container NameContainer'>
            <div className="row mt-5 " >
            <div className="col col-sm-auto" >
                <h1 className = 'editText2' style = {{fontSize : '30px' }}> Got an Idea! What's Next?</h1>
            </div>
            </div>
            <div className="row mt-3" >
            <div className="col col-sm-auto" >
                <h3 className = 'editText2' style = {{fontSize : '30px' }}> Get it built</h3>
            </div>
            </div>
            <div className="row mt-5" >
            <div className="col col-sm-auto" >
            <h1 className = 'editText' style = {{marginBottom : '2rem'}}>
            Insanely Fast!</h1>
            </div>
            </div>
            
           
            <div className = 'HomeBtn'>
            <div className = 'HomeBtnLink' onClick = {props.onContactClick}>Contact Us</div>
            </div>
        </div>
    )
}

export default Name
